import { render, staticRenderFns } from "./musteribilgipart.vue?vue&type=template&id=5b2dfd76&"
import script from "./musteribilgipart.vue?vue&type=script&lang=js&"
export * from "./musteribilgipart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports